module.exports = __webpack_public_path__ + "img/5-1.8bb74206.svg";